import { Text } from "@mantine/core";
import { COMPANY_NAME } from "@project/common";

export const CompanyDateFooter = () => {
  return (
    <Text size="xs">
      ©
      {" "}
      {COMPANY_NAME}
      {" "}
      {new Date().getFullYear()}
    </Text>
  );
};
